export const PUBLIC_IMAGE_REPORT_TURNSTILE_ACTION = 'public_image_report';
// Public lead/contact forms — each one is its own Turnstile action so the
// server can verify a token was minted for that form and Cloudflare analytics
// can tell them apart.
export const CONTACT_FORM_TURNSTILE_ACTION = 'contact_form';
export const WORKSHOP_CONTACT_TURNSTILE_ACTION = 'workshop_contact';
export const CREATOR_APPLICATION_TURNSTILE_ACTION = 'creator_application';
